var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons / icon_x_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45711 2.89645C4.65237 2.70118 4.96895 2.70118 5.16421 2.89645L8.52306 6.2553L11.8819 2.89645C12.0772 2.70118 12.3938 2.70118 12.589 2.89645L13.6497 3.95711C13.8449 4.15237 13.8449 4.46895 13.6497 4.66421L10.2908 8.02306L13.6495 11.3817C13.8448 11.577 13.8448 11.8936 13.6495 12.0888L12.5888 13.1495C12.3936 13.3448 12.077 13.3448 11.8817 13.1495L8.52306 9.79083L5.1644 13.1495C4.96914 13.3448 4.65255 13.3448 4.45729 13.1495L3.39663 12.0888C3.20137 11.8936 3.20137 11.577 3.39663 11.3817L6.7553 8.02306L3.39645 4.66421C3.20118 4.46895 3.20118 4.15237 3.39645 3.95711L4.45711 2.89645Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconX);
export default __webpack_public_path__ + "static/media/icon_x.f305d13ddb0380b6dedb199ddb6e28f2.svg";
export { ForwardRef as ReactComponent };